var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInverseLogoGraboxyAnticheat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "427px",
    height: "56px",
    viewBox: "0 0 427 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-anticheat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.000027%",
    y1: "18.6870588%",
    x2: "50.3888371%",
    y2: "-11.6620588%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3355",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C766F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.9998876%",
    y1: "18.6870787%",
    x2: "50.388764%",
    y2: "-11.6621348%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3355",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C766F4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-23.000000, -297.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-anticheat",
    transform: "translate(23.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5443054,23.8050977 C86.2537919,22.6731046 84.3850119,22.0345729 82.7980974,22.0345729 C78.9859633,22.0345729 76.4643427,24.2259623 76.4643427,28.5362676 C76.4643427,31.3663122 78.0512573,34.8928919 82.7980974,34.8928919 C84.2364955,34.8928919 85.5270091,34.6752247 87.1139236,33.4851664 L87.1139236,30.3068542 L82.2937733,30.3068542 L82.2937733,26.6350806 L91,26.6350806 L91,35.3282882 C89.2797366,37.7954717 86.4762507,39 82.7235232,39 C74.9513703,39 72,33.7028335 72,28.5362676 C72,22.948837 75.3817523,18 82.7829297,18 C85.5124734,18 88.033462,18.7111287 90.3326237,21.0331801 L87.5443054,23.8050977 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,38 L108.96119,38 L103.773547,31.4550492 L100.533408,31.4550492 L100.533408,38 L96,38 L96,18 C99.3148726,18 102.346645,18 105.587417,18 C110.492593,18 113.078498,21.1994273 113.078498,24.7640642 C113.078498,27.3937348 112.290629,29.6727618 108.396256,31.0313886 L113.940466,37.6493566 L113.940466,38 L114,38 Z M100.518842,21.8422012 L100.518842,27.671299 L105.705851,27.671299 C107.802188,27.671299 108.664156,26.108125 108.664156,24.8955321 C108.664156,23.5369053 107.727455,21.8422012 105.631751,21.8422012 L100.518842,21.8422012 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65183,34.5814595 L123.274052,34.5814595 L121.832236,38 L117,38 L126.010081,18 L130.915801,18 L140,38 L135.168397,38 L133.65183,34.5814595 Z M128.462941,22.5580541 L124.924284,30.6661791 L131.912275,30.6661791 L128.462941,22.5580541 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.099007,18.0146283 C157.002204,18.0146283 160.312675,19.7238987 160.312675,23.4200658 C160.312675,25.0562568 159.568532,26.6194308 157.594284,27.4813801 C160.25185,28.4017803 161.345419,30.973 160.905402,33.310478 C160.312675,36.5099053 157.518577,38 153.387605,38 C150.077134,38 146.386826,38 143,38 L143,18 L153.099007,18 L153.099007,18.0146283 Z M147.434452,25.7721097 L153.038828,25.7721097 C154.875894,25.7721097 155.757219,25.0562568 155.757219,23.8582923 C155.757219,22.7187788 154.875894,21.7984407 153.099007,21.7984407 L147.434452,21.7984407 L147.434452,25.7721097 Z M147.434452,34.1724273 L153.099007,34.1724273 C155.164492,34.1724273 156.121526,33.3251063 156.121526,31.8934001 C156.121526,30.4762602 155.088784,29.5412939 153.023299,29.5412939 C151.185586,29.5412939 149.272165,29.5412939 147.419569,29.5412939 L147.419569,34.1724273 L147.434452,34.1724273 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.499686,42 C170.071939,42 164,35.9250062 164,28.5 C164,21.0603006 170.071939,15 177.499686,15 C184.928061,15 191,21.0749937 191,28.5 C191,35.9250062 184.928061,42 177.499686,42 Z M177.499686,18.8445845 C172.208955,18.8445845 167.846378,23.1293361 167.846378,28.4853069 C167.846378,33.8412776 172.135481,38.1260919 177.499686,38.1260919 C182.791045,38.1260919 187.153622,33.8412776 187.153622,28.4853069 C187.138551,23.1293361 182.775974,18.8445845 177.499686,18.8445845 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "207.098438 18 211.927521 18 211.927521 18.2191133 205.282158 27.9634916 212 37.8539038 212 38 207.11318 38 202.499692 30.9583716 197.88682 38 193 38 193 37.8539038 199.7031 27.9634916 193.129602 18.2191133 193.129602 18 197.959299 18 202.572172 25.1146455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "224.90504 25.9765947 229.916212 18.0145661 235 18.0145661 235 18.2337416 227.01775 30.0379713 227.01775 38 222.632821 38 222.632821 30.0964224 215 18.2191133 215 18 220.083788 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.253853,25.2030157 C182.816716,25.8646348 182.153629,26.3007166 181.279999,26.3007166 C179.89413,26.3007166 178.718804,25.1277939 178.718804,23.744391 C178.718804,23.1579296 179.005093,22.7218479 179.306788,22.2857021 C178.869651,22.2105443 178.508259,22 177.99602,22 C174.712042,22 172,24.7067693 172,28 C172,31.2932307 174.696637,34 177.99602,34 C181.279999,34 183.992041,31.2932307 183.992041,28 C184.05238,26.9623997 183.766092,26.0150145 183.253853,25.2030157 Z",
    id: "Path",
    fill: "#EB3865"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "161 49.6116309 164.501084 52 173 39.388307 169.498918 37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7564168,23.3383529 C36.028299,24.4411176 34.9234751,25.1679412 33.4671807,25.1679412 C31.1571212,25.1679412 29.1985912,23.2130588 29.1985912,20.9072941 C29.1985912,19.9298235 29.6757091,19.203 30.1778856,18.4761764 C29.449709,18.3508823 28.8471206,18 27.9934144,18 C22.5196483,18 18,22.5112941 18,28 C18,33.4887059 22.4945307,38 27.9934144,38 C33.4671807,38 37.9867701,33.4887059 37.9867701,28 C38.0871819,26.2707059 37.610123,24.6917647 36.7564168,23.3383529 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.552752,33.8040995 L247.432541,33.8040995 L245.497006,38 L242,38 L251.21409,18 L254.78591,18 L264,38 L260.503633,38 L258.552752,33.8040995 Z M253,21.3771775 L248.663431,30.8947458 L257.351915,30.8947458 L253,21.3771775 Z",
    id: "Shape",
    fill: "#EB3865"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EB3865",
    points: "282.798681 32.2251472 282.798681 18 286 18 286 38 283.573475 38 272.230592 23.8772009 272.230592 38 269 38 269 18 271.455797 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.842372,20.880138 L291,20.880138 L291,18 C296.976142,18 302.024506,18 308,18 L308,20.880138 L301.188079,20.880138 L301.188079,38 L297.827471,38 L297.827471,20.880138 L297.842372,20.880138 Z",
    id: "Path",
    fill: "#EB3865"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EB3865",
    points: "313 38 313 18 316 18 316 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,35.9957571 C336.945025,38.052815 334.292624,39 331.508565,39 C324.279202,39 321.029373,33.9386992 321.000185,28.6109811 C320.970997,23.2832628 324.395955,18 331.508565,18 C334.190154,18 336.784801,19.0063328 338.796304,21.0633907 L336.653765,23.1500856 C335.225405,21.7294028 333.344938,21.0633907 331.494281,21.0633907 C326.421741,21.0633907 324.118977,24.8520044 324.148165,28.5814071 C324.177354,32.2811729 326.349081,35.9513648 331.494281,35.9513648 C333.344938,35.9513648 335.399913,35.166994 336.799084,33.7463111 L339,35.9957571 Z",
    id: "Path",
    fill: "#EB3865"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EB3865",
    points: "358.816993 38 358.816993 29.6812693 348.212382 29.6812693 348.212382 38 345 38 345 18 348.212382 18 348.212382 26.713422 358.816993 26.713422 358.816993 18 362 18 362 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,38 L369,38 C369,31.3479307 369,24.6520692 369,18 L383.910865,18 L383.910865,21.11405 L372.249325,21.11405 L372.249325,26.508788 L383.436109,26.508788 L383.436109,29.476573 L372.249325,29.476573 L372.249325,34.8420954 L384,34.8420954 L384,38 Z",
    id: "Path",
    fill: "#EB3865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.552113,33.8040995 L393.432541,33.8040995 L391.496367,38 L388,38 L397.214091,18 L400.785909,18 L410,38 L406.502994,38 L404.552113,33.8040995 Z M399.014707,21.3771775 L394.678138,30.8947458 L403.366623,30.8947458 L399.014707,21.3771775 Z",
    id: "Shape",
    fill: "#EB3865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.842372,20.880138 L410,20.880138 L410,18 C415.976142,18 421.024506,18 427,18 L427,20.880138 L420.188079,20.880138 L420.188079,38 L416.82747,38 L416.82747,20.880138 L416.842372,20.880138 Z",
    id: "Path",
    fill: "#EB3865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,2.51685393 C13.9260674,2.51685393 2.51685393,13.9260674 2.51685393,28 C2.51685393,42.0739326 13.9260674,53.483146 28,53.483146 C42.0739326,53.483146 53.483146,42.0739326 53.483146,28 C53.483146,13.9260674 42.0739326,2.51685393 28,2.51685393 Z M0,28 C0,12.536009 12.536009,0 28,0 C43.463991,0 56,12.536009 56,28 C56,43.463991 43.463991,56 28,56 C12.536009,56 0,43.463991 0,28 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EF3254",
    points: "26 51 26 41 29 41 29 51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CE5BD5",
    points: "26 15 26 5 29 5 29 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CE5BD5",
    points: "15 30 5 30 5 27 15 27"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EF3254",
    points: "51 30 41 30 41 27 51 27"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverseLogoGraboxyAnticheat);
export default __webpack_public_path__ + "static/media/inverse-logo-graboxy-anticheat.c975c54f0792120950906bb64d9686b4.svg";
export { ForwardRef as ReactComponent };